/**
 * Created by Ning Jiang on 3/3/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {BackgroundAnimationsController} from "../../background/BackgroundAnimationsController";
import {WildNudgeNudgeReelController} from "../../reel/nudgereel/WildNudgeNudgeReelController";
import {BurningMReelSymbol} from "../../reelsymbol/BurningMReelSymbol";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WildNudgeHelper} from "../../utils/WildNudgeHelper";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";

export class RandomFeatureAttentionController extends ReelStopPresentationController {

    private _featureSymbol:string = "";
    private _featureTriggered:boolean = false;
    private _hasWin:boolean = false;
    private _attentionStarted:boolean = false;

    constructor(index:number) {
        super(index, "RandomFeatureAttention");
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData):void {
        this._featureSymbol = data.activeStackedSymbol;
        this._featureTriggered = data.stackedSpinTriggered;
        this._hasWin = data.betWins != null && data.betWins.length > 0;
    }

    public onReelBounce(data:IReelStoppedData):void {
        this.playBouncePresentation(data);
        this.dispatchCompleteEvent(data.reelId);
    }

    private playBouncePresentation(data:IReelStoppedData):void {
        if(!this._featureTriggered) {
            return;
        }

        if(data.reelId === 0) {
            return;
        }

        // Start attention when second reel lands.
        if(data.reelId === 1) {
            if(data.quickStop && !this._hasWin) {
                // only play no win smoke on reel 3. to set this._attentionStarted = true will make it play.
            } else {
                this.playReelAttention(0);
                this.playReelAttention(1);
                SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.RANDOM_FEATURE_LANDING);
                EventHandler.dispatchEvent(new GameEvent(WildNudgeNudgeReelController.START_RANDOM_FEATURE, this._featureSymbol));
            }

            this._attentionStarted = true;
            return;
        }

        if(!this._attentionStarted) {
            return;
        }

        const bottomIndex = WildNudgeHelper.findStackedSymbolBottomPositionFromReelData(this._featureSymbol, data.reelId, this._gameData!.reels[data.reelId], 0);

        if(data.reelId > 1 && Reels.getSymbol(data.reelId, Math.min(4, bottomIndex)) && bottomIndex >= 0 && bottomIndex < 7) {
            SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.RANDOM_FEATURE_LANDING);
        }

        if(data.reelId === 2 && !this._hasWin) {
            this.playReelNoWin(0);
            this.playReelNoWin(1);
            this._attentionStarted = false;
            EventHandler.dispatchEvent(new GameEvent(WildNudgeNudgeReelController.STOP_RANDOM_FEATURE));
            SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.ATTENTION_EFFECT_FAIL);
            return;
        }

        this.playReelAttention(data.reelId);
    }

    private playReelAttention(reelId:number):boolean {
        const bottomIndex:number = WildNudgeHelper.findStackedSymbolBottomPositionFromReelData(this._featureSymbol, reelId, this._gameData!.reels[reelId], 0);
        Logger.logDev(`random feature attention reel=${reelId}, bottomIndex =${bottomIndex}`);
        if(bottomIndex >= 0 && bottomIndex < 7) {
            EventHandler.dispatchEvent(new GameEvent(SymbolBurstAnimator.PLAY_STACKED_SMOKE, reelId, 3));
            const symbol:BurningMReelSymbol = <BurningMReelSymbol>Reels.getSymbol(reelId, Math.min(4, bottomIndex));
            if(symbol) {
                symbol.changeState({
                    state : WildNudgeGameConfig.instance.SYMBOL_STATES.attention,
                    fadeInDuration : 0.1,
                    setStack : true
                });
                return true;
            } else {
                debugger;
            }
        }

        if(bottomIndex < 0 || bottomIndex >= 7) {
            const symbolIndex:number = bottomIndex < 0 ? -1 : 4;
            Logger.logDev(`RandomFeatureAttentionController.playReelAttention(); reelId = ${reelId} M symbol lands outside view, turn off the fire.`)
            const outsideSymbol:BurningMReelSymbol = <BurningMReelSymbol>Reels.getSymbol(reelId, symbolIndex);
            if(outsideSymbol) {
                outsideSymbol.stopFireOverlay(0.1, true, true);
            }
        }

        return false;
    }

    private playReelNoWin(reelId:number):void {
        const symbol:BurningMReelSymbol = <BurningMReelSymbol>Reels.getSymbol(reelId, 3);
        if(symbol) {
            symbol.changeState({
                state : WildNudgeGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.1,
                setStack : true
            });
        }
        symbol.stopFireOverlay(0.5, true, true);
        EventHandler.dispatchEvent(new GameEvent(BackgroundAnimationsController.PLAY_STACKED_NO_WIN_ANIM, reelId));
    }

    protected resetFeature():void {
        this._featureTriggered = false;
        this._attentionStarted = false;
    }
}